import { all, call, put, takeLatest, select } from 'redux-saga/effects';

import { Payment } from 'actions/actionTypes';
import * as actions from 'actions/billing/payment';

import { 
    callShopCharges, 
    callPaymentDate, 
    callShopChargesPaymentTokenIssuance, 
    callGeneralPayment 
} from 'network/apis/billing/payment';

function* loadShopChargesRequestSaga() {
    try {
        const payment = yield select(state => state.payment);

        const response = yield call(callShopCharges, payment.chargesPaymentType);

        yield put(actions.loadShopChargesRequestSuccess(response.data));
    } catch(error) {
        yield put(actions.loadShopChargesRequestFailure(error.message));
    }
}

function* loadPaymentDateRequestSaga() {
    try {
        const response = yield call(callPaymentDate);

        yield put(actions.loadPaymentDateRequestSuccess(response.data));
    } catch(error) {
        yield put(actions.loadPaymentDateRequestFailure(error.message));
    }
}

function* shopChargesPaymentRequestSaga(){
    try {
        const payment = yield select(state => state.payment);
        
        const billsIdx = [];
        payment.charges.forEach(function(item){
            billsIdx.push(item.shopBillIdx);
        });

        const data = {
            'chargesPaymentType': payment.chargesPaymentType,
            'chargesType': 'ShopMonthlyChargesPayment',
            'chargesData': {
                'idx': billsIdx
            }
        };

        const response1 = yield call(callShopChargesPaymentTokenIssuance, payment.paymentMethodType, data);

        const response2 = yield call(callGeneralPayment, response1.data.paymentGatewayUrl);

        yield put(actions.shopChargesPaymentRequestSuccess(response2.data));
    } catch(error) {
        yield put(actions.shopChargesPaymentRequestFailure(error.message));
    }
}

// Sign-In Sagas
export default function* root() {
    yield all([
        takeLatest(Payment.LOAD_SHOP_CHARGES_REQUEST, loadShopChargesRequestSaga),
        takeLatest(Payment.LOAD_PAYMENT_DATE_REQUEST, loadPaymentDateRequestSaga),
        takeLatest(Payment.SHOP_CHARGES_PAYMENT_REQUEST, shopChargesPaymentRequestSaga),
    ]);
}